<template>
  <ClientOnly>
    <div class="w-full text-center md:m-auto">
      <h2 class="heading-2 mb-32">
        {{ i18n(translations.attributesTitle) }}
      </h2>

      <VChart :class="$style.echarts" :option="chartOptions" />
    </div>
  </ClientOnly>
</template>

<script lang="ts" setup>
import { computed, useCssModule } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { PieChart, RadarChart } from 'echarts/charts'
import {
  LegendComponent,
  TimelineComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components'
import { use as useChart } from 'echarts/core'
import { SVGRenderer } from 'echarts/renderers'
import VChart from 'vue-echarts'

import translations from './SpiderChart.translations'
import type { ChartData } from './types'
import { buildChartOptions } from './utils'

const props = defineProps<{
  chartData: ChartData
}>()

const i18n = useI18n()

const chartOptions = computed(() =>
  props.chartData ? buildChartOptions(props.chartData) : null,
)

const $style = useCssModule()

useChart([
  RadarChart,
  SVGRenderer,
  LegendComponent,
  TimelineComponent,
  PieChart,
  TitleComponent,
  TooltipComponent,
])
</script>

<style module>
.echarts {
  height: 320px;
  width: 100%;
}

@media screen and (min-width: 480px) {
  .echarts {
    min-height: 400px;
    width: 730px;
  }
}
</style>
